<script lang="ts" setup>
import { GpFadeSlideTransition } from '@gportal/uikit';

const { isSelecting = false } = defineProps<{
  title: string;
  subtitle?: string;
  isSelecting?: boolean;
}>();

defineSlots<{
  toolbarSelectActions: () => void;
  toolbarTitle: () => void;
  toolbarSubTitle: () => void;
  toolbarMainAction: () => void;
  toolbarSearch: () => void;
}>();
</script>

<template>
  <div>
    <GpFadeSlideTransition mode="out-in" direction="down">
      <div
        v-if="isSelecting"
        class="tw-flex tw-min-h-10 tw-flex-wrap tw-items-center tw-justify-between"
      >
        <slot name="toolbarSelectActions" />
      </div>
      <div class="tw-flex tw-flex-wrap tw-items-center" v-else>
        <div class="tw-w-full sm:tw-w-1/2">
          <h1 v-if="title != null && title.length > 0" class="tw-text-4xl tw-font-bold">
            {{ title }}
          </h1>
          <slot name="toolbarTitle" />
          <p v-if="subtitle != null && subtitle.length > 0" class="tw-text-xs">
            {{ subtitle }}
          </p>
          <slot name="toolbarSubTitle" />
        </div>
        <div class="tw-mt-2 tw-flex tw-w-full tw-justify-end tw-gap-4 sm:tw-w-1/2 md:tw-mt-0">
          <slot name="toolbarMainAction"> </slot>
        </div>
      </div>
    </GpFadeSlideTransition>

    <div class="tw-mt-2 tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-end tw-gap-4">
      <slot name="toolbarSearch" />
    </div>
  </div>
</template>
